<nb-layout>
  <nb-layout-column>
        <div class="public-shared-container" *ngIf="!isError && !isSharedDataAvaliableBox">
            <nb-card>
                <nb-card-body>
                <div class="shared-liveview">
                    <h2 class="sub-title">
                    {{ title }}
                    </h2>
                </div>

                <div class="require-password-form" *ngIf="requirePassword">
                  <p class="introduction">
                    The link you're trying to access is PIN Code protected.
                    Please enter the PIN Code.
                  </p>

                  <form
                    aria-labelledby="title"
                    class="form-horizontal"
                    #requirePasswordForm="ngForm"
                    autocomplete="off"
                    novalidate
                    (submit)="
                      submitPassword(
                        requirePasswordForm.value,
                        requirePasswordForm.valid
                      )
                    "
                  >
                    <div class="row">
                      <div class="col-lg-10 col-md-10 col-sm-12">
                        <div
                          class="form-control-group"
                          [ngClass]="{
                            'has-error': !password.valid && password.touched,
                            'has-success': password.valid && password.touched
                          }"
                        >
                          <span class="label-with-link">
                            <label for="input-password" class="label">
                              PIN Code :
                            </label>
                          </span>
                          <input
                            nbinput
                            fullwidth
                            name="password"
                            type="password"
                            id="password"
                            placeholder="Enter 4-digit pin code"
                            fieldsize="medium"
                            class="input-full-width size-medium status-basic shape-rectangle nb-transition"
                            required
                            ngModel
                            #password="ngModel"
                            maxlength="4"
                            (keypress)="numberOnly($event)"
                          />
                          <div
                            class="alert alert-danger"
                            *ngIf="
                              (submitted && !password.valid) ||
                              (password.touched && !password.valid)
                            "
                            style="position: absolute; z-index: 100"
                          >
                            <div>
                              PIN code is required.
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-2 col-md-2 col-sm-12 div_btnenter">
                        <button
                          nbButton
                          matRipple
                          hero
                          fullwidth
                          status="info"
                          size="large"
                          aria-disabled="false"
                          tabindex="-1"
                          class="appearance-filled full-width size-large shape-rectangle status-primary nb-transition"
                          type="submit"
                          [disabled]="requirePasswordForm.invalid"
                        >
                          Enter
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
                
                <div class="divliveVideo"  *ngIf="!requirePassword && isStart">
                    <div class="livevideo" id="livevideo" *ngIf="data!=null">
                      <span class="camera-name">Camera # {{deviceId}}</span>
                      <div class="live_video_info"  *ngIf="data.conference != null && data.conference.ready != true ">
                        Loading live stream...
                      </div>
                      <video id="video{{data.device}}" autoplay  controls playsinline></video>
                      <div class="hidden">
                        <audio style="margin-top:23px;" id="local{{data.device}}" autoplay muted  onloadstart="this.volume=0" controls playsinline></audio>
                        <div>
                          <div *ngIf="data.conference != null">
                            <div *ngFor="let remoteVideo of data.conference.remoteVideos">
                              {{remoteVideo}}
                              <audio style="margin-top:23px;" class="audio{{data.device}} " id="{{remoteVideo}}" autoplay  controls playsinline></audio>
                            </div>
                          </div>
                          <div style="margin-top:10px;display: none;"  class="col-sm-8 offset-sm-2">Microphone Gain: <input type=range id=volume_change_input min=0 max=1 value=1 step=0.01></div>
                        </div>
                      </div>
                      <div class="liveViewControlLeft" [ngClass]="{'inActive':(data.conference==null || !data.conference.ready == true) }">
                        <div class="divVolume" *ngIf="data.conference!=null">
                          <i class="action fas" (click)="volumeOnOff(data)" 
                          [ngClass]="{
                            'fa-volume-mute': (data.conference == null || data.conference.volume === 0),
                            'fa-volume-up':   (data.conference != null && data.conference.volume > 0)
                          }" ></i>
                          <input class="pointVolume" name="pointVolume"  max="100" min="0" type="range"  [(ngModel)]="data.conference.volume"  (change)="volumeUpdate(data)">
                        </div>
                        <div class="liveTimer" *ngIf="data.conference!=null && data.conference.livetimer!=null">{{data.conference.livetimer}}</div>
                      </div>
                      <div class="video-control" *ngIf="data.conference != null" [ngClass]="{'inActive':(data.conference==null || !data.conference.ready == true) }">
                        <div class="videotimer2 d-flex align-items-center justify-content-end " *ngIf="data.conference.isrecording != null && data.conference.isrecording == true" preload="auto"> <img
                          src="../../../assets/images/live-record.gif">
                          <div class="runTimer">{{data.conference.runTimer}}</div>
                        </div>
                        <i class="fa-solid action"
                          [ngClass]="{
                            'fa-microphone': (data.conference == null || !data.conference.isMicMute),
                            'fa-microphone-slash': (data.conference != null && data.conference.isMicMute),
                            'color-red': (data.conference != null && data.conference.isMicMute)
                          }"
                          title="{{data.conference.isMicMute ? 'Enable Microphone' : 'Disable Microphone'}}"
                          (click)="switchMic(data)"></i>
                        <i class="fas fa-expand" title="Toggle Fullscreen Mode" (click)="zoomConference(data)" ></i>
                    </div>

                    </div>

                    <div class="livevideo"  *ngIf="data==null">
                      <span class="camera-name">Camera #  {{deviceId}}</span>
                      <div class="videotimer d-flex align-items-center justify-content-end hidden"> <img src="../../../assets/images/icon-record.gif">
                        <div id="runTimer" class="runTimer">00:00:00</div>
                      </div>
                      <iframe [src]="videodemo| safe: 'resourceUrl'"frameborder="0" allowfullscreen></iframe>
                      <div class="liveViewControlLeft inActive">
                        <div class="divVolume">
                          <i class="fas fa-volume-mute" ></i>
                          <input class="pointVolume" name="pointVolume"  max="100" min="0" type="range">
                        </div>
                      </div>
                      <div class="video-control inActive">
                        <i class="fa-solid fa-microphone" title="Enable Microphone"></i>
                        <i class="fas fa-expand" title="Toggle Fullscreen Mode" ></i>
                      </div>
                    </div>

                  </div>
                <div class="div-footer" *ngIf="!requirePassword && isStart"> 
                    <button
                      nbButton
                      status="danger"
                      tabindex="-1"
                      class="status-danger"
                      type="button"
                      (click)="onStop()"
                      [disabled] = "!isReady"
                    >
                      Exit
                    </button>
                </div>
            </nb-card-body>
      </nb-card>
    </div>

    <div class="public-shared-container"*ngIf="isError">
      <nb-card>
        <nb-card-body>
          <div class="shared-files">
            <h2 class="sub-title">
              {{ title }}
            </h2>
            
            <div class="alert-box-custom-danger" *ngIf="isSharedDataAvaliableBox">
              <div class="alert-box-content-danger"><div class="message"><span class="text">{{messages.no_data}}</span></div></div>
            </div>

            <div class="alert-box-custom" *ngIf="isSharedExpired">
              <div class="alert-box-content">
                <div class="message">
                  <span class="text">
                    {{messages.expired}}
                    {{ expiryDate | date : "MMM dd, yyyy HH:mm" }}.
                  </span>
                </div>
              </div>
            </div>

            <div class="alert-box-custom-warning" *ngIf="isOffline">
              <div class="alert-box-content-warning"><div class="message"><span class="text">{{messages.is_offline}}</span> </div></div>
            </div>

            <div class="alert-box-custom-danger" *ngIf="isStreamError"><div class="alert-box-content-danger">
                <div class="message"><span class="text">{{messages.stream_error}}</span></div></div>
            </div>

            <div class="alert-box-custom-warning" *ngIf="isExceeded">
              <div class="alert-box-content-warning"><div class="message"><span class="text">{{messages.stream_exceeded}}</span> </div></div>
            </div>

            <div class="alert-box-custom-warning" *ngIf="isDisconnected">
              <div class="alert-box-content-warning"><div class="message"><span class="text">{{messages.device_disconnected}}</span> </div></div>
            </div>

            <div class="alert-box-custom" *ngIf="!isSharedDataAvaliableBox && !isSharedExpired && !isOffline && !isStreamError && !isExceeded && !isDisconnected" >
              <div class="alert-box-content">
                <div class="message">
                  <span class="text">
                    {{messages.error}}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </nb-card-body>
      </nb-card>
    </div>
     <!-- <div class="hidden"></div> -->
    <div class="hidden">
      <div  *ngFor="let localvideo of localVideos">
        <video style="margin-top:23px;" id="{{localvideo}}" autoplay muted  onloadstart="this.volume=0" controls playsinline></video>
        <div style="margin-top:10px;display: none;"  class="col-sm-8 offset-sm-2">Microphone Gain: <input type=range id=volume_change_input min=0 max=1 value=1 step=0.01></div>
      </div>

      <div style="margin-top:10px;display: none;"  class="col-sm-8 offset-sm-2">Microphone Gain: <input type=range id=volume_change_input min=0 max=1 value=1 step=0.01></div>
    </div>
    <div class="hidden">
      <div *ngFor="let remoteVideo of remoteVideos">
        {{remoteVideo}}
        <audio style="margin-top:23px;" id="{{remoteVideo}}" autoplay  controls playsinline></audio>
      </div>
    </div>
    </nb-layout-column>
</nb-layout> 

<loading *ngIf="loading" message="{{ loadingMessage }}"></loading>